import { FunctionComponent, PropsWithChildren } from 'react';

export const DisplayCancellableData: FunctionComponent<PropsWithChildren & { isCancelled?: boolean | undefined }> = ({
    isCancelled = false,
    children,
}) => {
    return isCancelled ? <span className="text-decoration-line-through">{children}</span> : children;
};
